const { iaRa } = require('lib/helpers/utility');

export const providerOptions = (providers, name = 'name', value = 'id') => {
  return iaRa(providers).map((provider) => ({
    label: provider[name],
    value: provider[value],
    ...provider
  }));
};
